import React, { useEffect, useState } from 'react';
import { Input, Popover } from '@thimble/core-lib';
import useRequest from '../hooks/useRequest';
import { ActivityAnswer, apiActivitySearch } from '../apis/profession';
import { PopupPreset } from '../utils/popupPreset';
import Spin from '../atoms/Spin';
import ICInput from '../atoms/ICInput';

const activitySearchCache: Record<string, ActivityAnswer[]> = {};
const cachedApiActivitySearch = async (query: string) => {
  return (
    activitySearchCache[query] || (activitySearchCache[query] = await apiActivitySearch(query))
  );
};

const ProfessionControl: React.FC<{
  value?: ActivityAnswer | null;
  onChange?: (value: ActivityAnswer | null) => void;
}> = ({ value, onChange }) => {
  const [
    { value: activities, loading: activitiesLoading },
    triggerActivitySearch,
    clearActivitySearch,
  ] = useRequest(cachedApiActivitySearch);

  const [query, setQuery] = useState('');
  useEffect(() => {
    if (query.length > 1) triggerActivitySearch(query);
    else if (query.length === 0) clearActivitySearch();
  }, [query, triggerActivitySearch, clearActivitySearch]);

  return (
    <>
      <Popover
        visible={!!(activitiesLoading || activities?.length)}
        popup={
          <div style={{ fontSize: 16 }}>
            {activitiesLoading ? (
              <Spin />
            ) : activities ? (
              activities.map(activity => (
                <div
                  key={activity.id}
                  onClick={() => {
                    onChange?.(activity);
                    clearActivitySearch();
                  }}
                  className="insurance-calculator-widget__pop-option"
                >
                  {activity.activity}
                </div>
              ))
            ) : null}
          </div>
        }
        popupPreset={PopupPreset}
      >
        <ICInput
          label={['Profession', null]}
          placeholder="Handymen"
          value={value?.activity || query}
          onChange={value ? undefined : setQuery}
          readOnly={!!value}
          clearable
          onClear={
            value
              ? () => {
                  setQuery('');
                  onChange?.(null);
                }
              : undefined
          }
        />
      </Popover>
    </>
  );
};

export default ProfessionControl;
